module.exports = __webpack_public_path__ + "img/geofisica3_4-3.cfc6fe47.webp";